<template>
    <div class="netto-bidding-summary">
        <span class="netto-bidding-summary__text">Dein Gebot</span>
        <span class="netto-bidding-summary__value">{{ bidFormatted }}</span>
    </div>
</template>

<script>
import formatPrice from '@/filters/formatPrice';

export default {
    name: 'NettoBiddingCheckoutSummary',
    props: {
        bidAmount: {
            // cannot type Null here (unsafe query string)
            required: true
        }
    },
    computed: {
        bidFormatted() {
            return formatPrice(this.bidAmount);
        }
    }
};
</script>

<style scoped lang="scss">
.netto-bidding-summary {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    color: var(--primary);

    &__text {
        font-weight: 500;
    }

    &__value {
        margin-left: auto;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1.5;
    }
}
</style>
